module.exports = __webpack_public_path__ + "static/media/cross.ab8ff42d.svg";